import { buildPublicUrl } from '@/lib/globals';

// TODO: reduce size of these
export const garamondNarrowLight = buildPublicUrl(`webFonts/ITCGaramondStdLtNarrow/font.woff`);
export const garamondNarrowBook = buildPublicUrl(`webFonts/ITCGaramondStdBkNarrow/font.woff`);
export const garamondNarrowBookItalic = buildPublicUrl(`webFonts/ITCGaramondStdBkNarrowIta/font.woff`);
export const garamondNarrowLightItalic = buildPublicUrl(`webFonts/ITCGaramondStdLtNarrowIta/font.woff`);
export const helveticaNeue = buildPublicUrl(`webFonts/HelveticaNeueLTStd-Bd.otf`);
export const monaco = buildPublicUrl(`webFonts/Monaco.woff`); // 120KB!!
export const celophane = buildPublicUrl(`webFonts/celophaneCT.ttf`);
export const hooge = buildPublicUrl(`webFonts/Hooge0656.ttf`);
